import { ProductType } from '@floori-web-components';

export const disabledRotationProductTypes: ProductType[] = [ProductType.epoxy, ProductType.paint];

export const disabledMovePatternProductTypes: ProductType[] = [
    ProductType.paint,
    ProductType.rug,
    ProductType.grout,
];

export const boostRenderSupportedProductTypes: ProductType[] = [
    ProductType.engineeredHardwood,
    ProductType.solidHardwood,
    ProductType.laminate,
    ProductType.bambooFlooring,
    ProductType.parquet,
    ProductType.timber,
    ProductType.epoxy,
    ProductType.epoxyBase,
    ProductType.epoxyChips,
    ProductType.lvtVinyl,
    ProductType.lvp,
    ProductType.spc,
    ProductType.hybridFloor,
    ProductType.rigidVinyl,
    ProductType.wpc,
    ProductType.pvc,
];
